// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dq-2";
export var aiChatCartContainerExit = "_dq-4";
export var aiChatContainerLarge = "_dq-0";
export var aiChatContainerSmall = "_dq-1";
export var aiChatIcon = "_dq-6";
export var slideInFromRight = "_dq-3";
export var slideOutToRight = "_dq-5";